// src/app/interceptors/unauth-community.interceptor.ts
import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../guards/service/auth.service';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

export const unauthCommunityInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const auth = inject(AuthService);

  return next(req).pipe(
    catchError(err => {
      const status = err?.status ?? 0;
      const switching = sessionStorage.getItem('switchingCommunity') === '1';
      if (switching && (status === 401 || status === 403)) {
        return throwError(() => err);
      }
      return throwError(() => err);
    })
  );
};
